<template>
    <app-layout>
      <Head title="Contacts"/>
        <template #header>
            <div class="flex justify-between items-center">
                <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                    Contacts
                </h2>
                <div class="text-right">
                    <div class="sm:inline-block">
                        <button
                            @click="showImportModal = true"
                            class="text-gray-700 mr-4 py-2 mb-2"
                        >
                            Import Contacts
                        </button>
                    </div>
                    <jet-button @click.native="showCreateModal = true"
                        >Add Contact</jet-button
                    >
                </div>
            </div>
        </template>

        <div class="max-w-7xl mx-auto flex mb-6">
            <div class="w-full p-2 sm:px-6 lg:px-8">
                <div class="bg-white shadow-xl sm:rounded-lg p-4 sm:p-6 lg:p-8 overflow-hidden relative">
                    <contact-table ref="contactTable"></contact-table>
                    <contact-create-modal
                        v-if="showCreateModal"
                        :is-open="showCreateModal"
                        @close="showCreateModal = false"
                    ></contact-create-modal>
                    <contact-import-modal
                        v-if="showImportModal"
                        :is-open="showImportModal"
                        @close="showImportModal = false"
                    ></contact-import-modal>
                </div>
            </div>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from "../../Layouts/AppLayout";
import JetDropdown from "../../Jetstream/Dropdown";
import JetDropdownLink from "../../Jetstream/DropdownLink";
import JetDialogModal from "../../Jetstream/DialogModal";
import JetSecondaryButton from "../../Jetstream/SecondaryButton";
import JetNavLink from "../../Jetstream/NavLink";
import JetButton from "../../Jetstream/Button";
import JetDangerButton from "../../Jetstream/DangerButton";
import ContactTable from "../../components/ContactTable";

import axios from "axios";
import ContactCreateModal from "../../components/ContactCreateModal";
import ContactImportModal from "../../components/ContactImportModal";


export default {
    mounted() {
    },
    components: {
        ContactCreateModal,
        ContactImportModal,
        AppLayout,
        JetDropdown,
        JetDropdownLink,
        JetDialogModal,
        JetNavLink,
        JetButton,
        JetSecondaryButton,
        JetDangerButton,
        ContactTable
    },
    props: {
        data: Array,
        links: Object,
        meta: Object
    },
    data() {
        return {
            showCreateModal: false,
            showImportModal: false,
            showDeletionModal: false,
            showEditModal: false,
            contactEditDetails: {
                first_name: null,
                last_name: null,
                phone_number: null,
                id: null
            },
            contactSetForDeletion: null
        };
    },
    computed: {
        contactDeleteRoute: function() {
            if (!this.contactSetForDeletion) {
                return "";
            }

            return route("contacts.delete", {
                id: this.contactSetForDeletion
            });
        }
    },
    methods: {
        toggleDeletionModal(row) {
            if (!this.showDeletionModal) {
                this.contactSetForDeletion = row.id;
            }
            this.showDeletionModal = !this.showDeletionModal;

        },
        toggleEditModal(row) {
            if (!this.showEditModal) {
                this.contactEditDetails.first_name = row.first_name;
                this.contactEditDetails.last_name = row.last_name;
                this.contactEditDetails.phone_number = row.phone_number;
                this.contactEditDetails.id = row.id;
            }
            this.showEditModal = !this.showEditModal;
        },
    }
};
</script>
